import { AxiosInstance } from 'axios';
import {
  BulkJobServicesEndpoint,
  BulkJobUpdatePricesRequest,
  BulkJobUpdateUserRequest,
  BulkJobDatesRequest,
} from './BulkJobServices.types';
import {
  BulkJobStatusServicesEndpoint,
  BulkJobStatusServices,
  BulkJobLoadboardServicesEndpoint,
  BulkJobLoadboardServices,
} from './services';

export class BulkJobServices implements BulkJobServicesEndpoint {
  instance: AxiosInstance;
  status: BulkJobStatusServicesEndpoint;
  loadboard: BulkJobLoadboardServicesEndpoint;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
    this.status = new BulkJobStatusServices(instance);
    this.loadboard = new BulkJobLoadboardServices(instance);
  }

  updatePrices(request: BulkJobUpdatePricesRequest) {
    return this.instance.put('/bulk/job/prices', request.body);
  }

  updateUser(request: BulkJobUpdateUserRequest) {
    return this.instance.put('/bulk/job/users', request.body);
  }

  updateDates(request: BulkJobDatesRequest) {
    return this.instance.put(`/bulk/job/dates/${request.routeParams.dateType}`, request.body);
  }
}
